import React from 'react'
import styled from 'styled-components'

import ResetPasswordSuccessImg from '../../../images/illo-couple-phone.svg'

const ResetSuccessImg = styled.img`
  height: 263px;
  width: 300px;
`
const ResetPasswordSuccessImage = () => (
    <ResetSuccessImg src={ResetPasswordSuccessImg} />
)

export default ResetPasswordSuccessImage
